module.exports = __webpack_public_path__ + "img/videowiki-cast.139dfab6.svg";